import axios from 'axios';
import React, { useEffect } from 'react';
import { BASE_URL } from '../../../insightConfig/insightConfig';

const CUET_Resources = () => {
    const courses = [
        { name: 'History Optional (Online)', link: '/course/History-Optional-Online' },
        { name: 'History Optional (Offline)', link: '/course/History-Optional-Offline' },
        { name: 'History & Culture', link: '/course/History-and-Culture' },
        { name: 'Art & Culture', link: '/course/Art-and-Culture-Course' },
        { name: 'History Optional Map Classes', link: '/course/history-optional' },
    ];
    const [downloads, setDownloads] = React.useState([]);
    useEffect(() => {
        axios.get(BASE_URL + '/cuet/user/resources').then((response) => {
            console.log(response.data);
            setDownloads(response.data.data);
        }
        ).catch((error) => {
            console.error("There was an error fetching the data!", error);
        });
    }, []);

    return (
        <div className='mx-'>
            <div className='History-container-box'>
                <div className='card History-card container'>
                    {/* Course Table Start */}
                    <table className="table" border="1">
                        <thead>
                            <tr className='text-center'>
                                <th colSpan="4" className='History1-course-heading table-border'>IMPORTANT RESOURCES FOR CUET PREPARATION</th>
                            </tr>
                        </thead>
                        <thead >
                            <tr >
                                <th className='History2-course-heading table-border'>S.No.</th>
                                <th className='History2-course-heading table-border'>File Name</th>
                                <th className='History2-course-heading table-border'>DownLoad</th>
                            </tr>
                        </thead>
                        <tbody>
                            {downloads?.map((course, index) => (
                                <tr key={index}>
                                    <td className='table-border'>{index + 1}</td>
                                    <td className='table-border table-data2'>{course.FileTitle}</td>
                                    <td className='table-border d-flex justify-content-center align-items-center '>
                                        <button className=' btn btn-sm fw-bold px-4 btn-danger' onClick={() => window.open(course.FilePath)}>Click</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* Course Table End */}
                </div>
            </div>



        </div>
    )
}

export default CUET_Resources